import React, { FC } from 'react';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
interface Props {
  isDisabled: boolean;
}
export const CollectButton: FC<Props> = ({
  isDisabled
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <Button id='default_button' color={'Black'} size={'medium'} disabled={isDisabled} data-sentry-element="Button" data-sentry-component="CollectButton" data-sentry-source-file="CollectButton.tsx">
            {tr({
      id: 'btn.collect'
    })}
        </Button>;
};